import {Component, HostListener, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {AuthService} from '../../services/auth.service';
import {User} from '../../models/user.model';
import {TestingService} from '../../services/testing.service';
import {NotificationsService} from '../../services/notifications.service';


@Component({
  selector: 'app-change-pass',
  templateUrl: './change-pass.component.html',
  styleUrls: ['./change-pass.component.css']
})
export class ChangePassComponent implements OnInit {
  private user: User;
  public signinError = false;
  public disableBtn = false;
  public remoteAccessError = false;
  public disabledUserError = false;
  public forgotDiv = false;
  visible = false;
  public login = '';
  public password = '';
  loginOld = '';
  passwordNewRepeat = '';
  passwordNew = '';
  passwordOld = '';
  repeatError = false;
  public formGroup: FormGroup;
  valid = false;

  constructor(
    private authService: AuthService,
    public notificationsService: NotificationsService,
    public testingService: TestingService) {
  }

  @HostListener('paste', ['$event'])
  checkOnPaste(event) {
    const clipboardText: string = event.clipboardData.getData('Text');
    this.isValidPaste(clipboardText.split(''), event);
  }

  private isValidPaste(arrayChar: string[], event) {
    arrayChar.forEach(function (value) {
      const charCode = value.charCodeAt(0);
      if (charCode > 128 || charCode === 32) {
        event.preventDefault();
      }
    });
  }

  ngOnInit() {
 
  }

  checkInput(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 128 || charCode === 32) {
      return false;
    }
    return true;
  }

  onChange() {
    this.visible = !this.visible;
    if(this.forgotDiv) {
      this.forgotDiv = !this.forgotDiv;
    }
  }

  changePassword() {
    if(this.passwordNew.length < 6 || this.passwordNewRepeat.length < 6) {
      this.valid = true;
    } else {
      this.valid = false;
      this.signinError = false;
      this.disableBtn = true;
      if(this.passwordNew !== this.passwordNewRepeat) {
        this.repeatError = true;
        setTimeout(() => {
          this.repeatError  = false;
          this.disableBtn = false;
        }, 3000);
      } 
      if(this.passwordNew === this.passwordNewRepeat) {
        this.authService.changePass(this.loginOld, this.passwordOld, this.passwordNew).subscribe(
          (response: any) => {
            window.location.replace('/signin');
          },
          () => {        
            this.signinError = true;
            this.disableBtn = false;
          }
        );
      }  
    }
  }

  onForgot() {
    this.forgotDiv = !this.forgotDiv;
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/auth/change-pass/change-pass.component.ts